import store from '../store';
import Riordino from '../views/riordinos/Index.vue';
import { checkauth } from '../Helper';

export default [
	{
		path: '/riordino',
		name: 'items',
		component: Riordino,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				// console.log(response)
				if (response) {
					//console.log("login")
					next();
				} else {
					//console.log("next")
					next('/login');
				}
			});
		},
	},
];
